import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';
class AnketSaveAPI extends BaseAPI {
  constructor() {
    const baseUrl = environment.API_URL + "AnketSave";
    super(baseUrl);
  }

  saveAnketSaveSave(request: AnketSaveRequest) {
    return this.post("", request, false);
  }
}
export default new AnketSaveAPI();

class AnketSaveRequest {
  tcKimlikNo: string;
  cevaplarXml: string;
  kullaniciId?: number;
  constructor(cevaplarXml: string, tcKimlikNo: string, kullaniciId?: number) {
    this.cevaplarXml = cevaplarXml;
    this.tcKimlikNo = tcKimlikNo;
    this.kullaniciId = kullaniciId;
  }
}
export { AnketSaveRequest };
